import useCartMetrics from '../../hooks/useCartMetrics';
export default () => {
    useCartMetrics();
    return null;
}